import React from 'react';
import Settings from '../../components/settings/settings';

const SettingsPage = () => {
  return <Settings />;
};

export default SettingsPage;
